import NavigationMain from "../../components/NavigationMain";
import FormLogin from "../../components/FormLogin";
import Layout from "../../components/Layout";

function Login() {
  return (
    <>
      <NavigationMain />
      <Layout>
        <FormLogin />
      </Layout>
    </>
  );
}

export default Login;
